"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import "../../api/api";
import InvoiceAbandonerForm from "./invoice_abandoner_form";
import documentsService from "../documents_service";
class InvoiceAbandoner extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "abandon", () => {
      if (this.props.isPaymentsNetworkSubmission && !this.state.reason.trim()) {
        this.setState({ error: true });
        return;
      }
      this.setState(
        {
          abandoning: true,
          error: false
        },
        () => {
          var _a, _b;
          if (this.state.selectedOption === "ignore") {
            if (this.props.isPaymentsNetworkSubmission && !this.state.reason.trim()) {
              this.setState({
                abandoning: false,
                error: true
              });
              return;
            }
            this.props.abandon(this.state.reason);
          } else if (this.props.isPaymentsNetworkSubmission && this.props.documentBatchId && this.state.duplicateInvoice) {
            (_b = (_a = this.props).markAsDuplicate) == null ? void 0 : _b.call(
              _a,
              this.props.documentBatchId,
              this.state.duplicateInvoice.id
            );
          }
        }
      );
    });
    __publicField(this, "fetchDocumentBatch", () => {
      if (this.props.markAsDuplicate && this.props.isPaymentsNetworkSubmission) {
        this.setState(
          {
            isLoading: true
          },
          () => __async(this, null, function* () {
            try {
              if (this.props.documentBatchId) {
                const batch = yield documentsService.getUncachedDocumentBatch(
                  this.props.documentBatchId
                );
                this.updateDocumentBatch(batch);
              }
            } finally {
              this.setState({
                isLoading: false
              });
            }
          })
        );
      }
    });
    __publicField(this, "handleChangeReason", (evt) => {
      this.setState({
        reason: evt.currentTarget.value
      });
    });
    __publicField(this, "handleOptionChange", (evt) => {
      this.setState({
        selectedOption: evt.currentTarget.value
      });
    });
    __publicField(this, "updateDocumentBatch", (documentBatch) => {
      const duplicateInvoice = documentBatch.duplicateInvoice;
      this.setState({
        duplicateInvoice
      });
    });
    this.state = {
      abandoning: false,
      duplicateInvoice: null,
      error: false,
      isLoading: false,
      reason: "",
      selectedOption: "ignore"
    };
  }
  componentDidMount() {
    this.fetchDocumentBatch();
  }
  componentDidUpdate(prevProps) {
    if (this.props.documentBatchId !== prevProps.documentBatchId) {
      this.fetchDocumentBatch();
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "modal__medium-container invoice__mark-complete" }, /* @__PURE__ */ React.createElement(
      InvoiceAbandonerForm,
      {
        abandon: this.abandon,
        abandoning: this.state.abandoning,
        duplicateInvoice: this.state.duplicateInvoice,
        error: this.state.error,
        isPaymentsNetworkSubmission: this.props.isPaymentsNetworkSubmission,
        onCancel: this.props.onCancel,
        onChangeOption: this.handleOptionChange,
        onChangeReason: this.handleChangeReason,
        selectedOption: this.state.selectedOption,
        reason: this.state.reason
      }
    ));
  }
}
export default InvoiceAbandoner;
